import React, { createContext, useContext, useState } from 'react';

const SessionKeyContext = createContext(null);

export const SessionKeyProvider = ({ children }) => {
  // 1. Existing Session Key State
  const [sessionKey, setSessionKey] = useState(null);
  
  // 2. NEW: Phone Number State (In-Memory only)
  // This will reset on refresh, adhering to your security requirements.
  const [phoneNumber, setPhoneNumberState] = useState(null);

  const setKey = (key) => {
    setSessionKey(key);
  };

  // 3. NEW: Setter for phone number
  const setPhoneNumber = (phone) => {
    setPhoneNumberState(phone);
  };

  const clearKey = () => {
    setSessionKey(null);
    setPhoneNumberState(null); // Clear phone number on logout/clear
  };

  return (
    <SessionKeyContext.Provider 
      value={{ 
        sessionKey, 
        setKey, 
        clearKey,
        // 4. Expose the phone number and its setter
        phoneNumber,
        setPhoneNumber
      }}
    >
      {children}
    </SessionKeyContext.Provider>
  );
};

export const useSessionKey = () => {
  return useContext(SessionKeyContext);
};